<template>
	<div class="xkit-ddl-wrapper" :id="wrapper_id" :class="{ 'active': opened }">
		<div class="xkit-ddl-control">
			<div class="xkit-ddl-input" @click="onDropdownClick">
				<div class="xkit-ddl-selected-value">
					<template v-if="! inputValue">
						<template v-if="state.multiple">
							<span class="item" v-for="item in dropdownSelectedValue" :data-value="item" ><span class="remove" role="presentation" @click="remove_item(item)">×</span> {{ get_text( item ) }}</span>
						</template>
						<template v-else>
 							{{ get_text( dropdownSelectedValue[0] ) }}
						</template>
					</template>
					<template v-else>
						{{ state.placeholder }}

					</template>

				</div>
				<div class="xkit-ddl-input-field">
					<input :class="{ 'v-none': ! inputValue }" autocapitalize="none" autocomplete="off" autocorrect="off" spellcheck="false" tabindex="0" type="text" aria-autocomplete="list" aria-expanded="false" aria-haspopup="true" role="combobox" aria-activedescendant="" placeholder="type to search..."
					       :value="inputValue"
					       @input="onInput" />
				</div>
			</div>
			<div class="xkit-ddl-buttons">
				<div class="xkit-ddl-buttons--clear" @click="clear" v-show="dropdownSelectedValue"><svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-8mmkcg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg></div>
				<span class="xkit-ddl-buttons--separator"></span>
				<div class="xkit-ddl-buttons--arrow" @click="onDropdownClick"><svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-8mmkcg"><path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg></div>
			</div>
		</div>
		<div class="xkit-ddl-menu" v-show="opened && ( inputValue || items.length )">
			<div class="xkit-ddl-list">
				<div class="xkit-ddl-item info">

				</div>
				<template v-for="(item, k) in items"
				     :key="k"
				     >
						<div
							v-if="! dropdownSelectedValue.some(i => i == item.value)"
							@click="selectItem(item.value)"
							:class="{ 'xkit-ddl-item': true, 'selected': dropdownSelectedValue.some(i => i == item.value)}"
							:data-value="item.value"
						>{{ item.text }}</div>
				</template>
				<div v-if="inputValue && ! items.length" class="xkit-ddl-item">no items found</div>
				<div v-if="false" v-show="items.length != 1 && inputValue"
				     @click="createOption(inputValue)"
				     class="xkit-ddl-item">Create "{{ inputValue }}"</div>
			</div>
		</div>
	</div>
</template>
<script setup>
import {nextTick, onMounted, onUnmounted, ref} from "vue";
import _debounce from "lodash/debounce";
import api from "../../../../vendor/xkit/js/api.js";

let $ = jQuery;
const props = defineProps({
	state: Object,
	select_id: String,
})
let items = ref([])

let wrapper_id = 'xkit-dropdown-' + props.select_id
let $wrapper = null
let $select = $('#' + props.select_id)
let $form = null
// add existing options
let initial_select_value = $select.val()
if ( ! Array.isArray( initial_select_value ) ) {
	initial_select_value = [initial_select_value]
}

let initial_select_options = []
$select.find('option').each(function(){
	initial_select_options.push( { value: this.value, text: $(this).text()})
})
items.value = initial_select_options

onMounted(function(){
	$wrapper = $( '#' + wrapper_id)
	$form = props.state.form ? $( props.state.form ) : $wrapper.parents('form')
})

const opened = ref( false )
const inputValue = ref( '' )
const dropdownSelectedValue = ref( initial_select_value )
let search_req = null

let search = function() {
	if ( search_req ) {
		search_req.abort()
	}

	XKIT_Utils.blockUI( $wrapper )

	let args = {
		term: inputValue.value,
	}

	$form.find(':input').each(function(){
		args[this.name] = $(this).val();
	})

	// args.action = $select.data( 'action' )
	args.action = props.state.action
	// args._wpnonce = xkit_params.xkit_nonce

	api.post(args, search_req )
	   .then(function( res ){
		   $wrapper.unblock()
		   if ( res.data.err ) {
			   return;
		   }
		   items.value = res.data.items
	   })
}
let debounced_search = _debounce(search, 900)
let onInput = (e) => {
	let search = e.target.value
	inputValue.value = search

	// handle non search - props.state.ajax_search == false
	debounced_search( search )
}


let onDropdownClick = function(){
	if ( opened.value ) {
		return
	}
	opened.value = true
	inputValue.value = ''

	nextTick(function(){
		$('input', $wrapper).focus()
	})

	$('.xkit-ddl-input-field input', '#' + wrapper_id).focus()
	// if ( props.state.form || items.value.length == 1 ) { // ! items.value.find( ( i ) => i.value != '' )
	items.value = []
		search()
	// }
}
let close = function () {
	inputValue.value = ''
	opened.value = false
}

let clear = function(){
	inputValue.value = ''
	dropdownSelectedValue.value = []
	$select.val( '' ).trigger('change')
	items.value = []
}
let cancel_search = function(){
	close()
}
let remove_item = function(value){
	const index = dropdownSelectedValue.value.findIndex(
		(i) => i == value
	);
	dropdownSelectedValue.value.splice(index, 1);
  $select.val( dropdownSelectedValue.value ).trigger('change')
}

let selectItem = function( value ){
	if ( ! props.state.multiple ) {
		$select.val( '' ).trigger('change')
		dropdownSelectedValue.value = []
	}
	if ( ! dropdownSelectedValue.value.some(i => i == value) ) {
		dropdownSelectedValue.value.push( value )

		if ( !$select.find( 'option[value="' + value + '"]' ).length ) {
			$select.append( $( '<option>', {
				value: value,
				text: get_text( value )
			} ) );
		}

		$select.val( dropdownSelectedValue.value ).trigger('change')
	}
	close()
}
let createOption = async function( value ){
	// if ( ! items.value.includes( value ) ) {
	if ( ! get_text( value ) ) {
		if ( props.onCreateOption ) {
			let res = await props.onCreateOption( { field_id: props.main_gf_field_id, value } )
			if ( res.data.err ) {
				return;
			}
		}
		items.value.push( value )
	}

	selectItem( value )
}

let gdlDdlOnClickOutside = function (e) {
// outside click
	let $closest_item = $(e.target).closest('.xkit-ddl-wrapper')
	// if ( ! $closest_item.length ) {
	if ( ! $closest_item.is( $wrapper ) ) {
		close()
	}
}
let get_text = function( value ){
	let searcable_items = items.value.concat(initial_select_options)
	let s_item = searcable_items.find( (item) => item.value == value )
	if ( s_item ) {
		return s_item.text
	}
	return null
}

onMounted(function(){
	$(document).off('mouseup', gdlDdlOnClickOutside )
	$(document).on('mouseup', gdlDdlOnClickOutside)
})
onUnmounted(function(){
	$(document).off('mouseup', gdlDdlOnClickOutside )
})
</script>
<style lang="scss">
@use "sass:selector";

.xkit-ddl-wrapper{
	$el: &;

	position: relative;
	box-sizing: border-box;

	.xkit-ddl-control {
		&:hover {
			border-color: rgb(179, 179, 179);
		}
		&.active {
			border-color: rgb(38, 132, 255);
		}

		-webkit-box-align: center;
		align-items: center;
		cursor: default;
		display: flex;
		flex-wrap: wrap;
		-webkit-box-pack: justify;
		justify-content: space-between;
		min-height: 38px;
		position: relative;
		transition: 100ms;
		background-color: rgb(255, 255, 255);
		border-color: rgb(38, 132, 255);
		border-radius: 4px;
		border-style: solid;
		border-width: 1px;
		box-shadow: rgb(38, 132, 255) 0px 0px 0px 1px;
		box-sizing: border-box;
		outline: 0px !important;

		.xkit-ddl-input {
			-webkit-box-align: center;
			align-items: center;
			//display: grid;
			display: list-item;
			flex: 1 1 0%;
			flex-wrap: wrap;
			position: relative;
			overflow: hidden;
			padding: 2px 8px;
			box-sizing: border-box;

			.xkit-ddl-selected-value {
				grid-area: 1 / 1 / 2 / 3;
				max-width: 100%;
				overflow-x: auto;
				//text-overflow: ellipsis;
				white-space: nowrap;
				color: rgb(51, 51, 51);
				margin-left: 2px;
				margin-right: 2px;
				box-sizing: border-box;

				.item {
					border: none;
					background: var(--ct-primary);
					color: #fff;
					border-radius: 3px;
					padding: 0px 7px 0 0;
					margin: 5px 5px 0 0;
				}
				.remove {
					color: #fff;
					margin-right: 7px;
					border-color: #a53a39;
					padding: 0 8px;
					cursor: pointer;
				}
			}
			.xkit-ddl-input-field {
				visibility: visible;
				display: none;
				flex: 1 1 auto;
				grid-area: 1 / 1 / 2 / 3;
				grid-template-columns: 0px min-content;
				///*margin: 2px;
				//padding-bottom: 2px;
				//padding-top: 2px;*/
				color: rgb(51, 51, 51);
				box-sizing: border-box;
				@at-root #{$el}.active .xkit-ddl-input-field {
					display: flex!important;
				}

				input {
					//background: 0px center;
					background: #fff;
					opacity: 0;
					width: 100%;
					height: 100%;
					font: inherit;
					min-width: 2px;
					border: 0 !important;
					outline: 0px;
					padding: 0!important;
					@at-root #{$el}.active .xkit-ddl-input-field input {
						opacity: 1!important;
					}
				}
			}
		}

		.xkit-ddl-buttons {
			-webkit-box-align: center;
			align-items: center;
			align-self: stretch;
			display: flex;
			flex-shrink: 0;
			box-sizing: border-box;
			.xkit-ddl-buttons--clear, .xkit-ddl-buttons--arrow {
				display: flex;
				transition: color 150ms;
				color: rgb(204, 204, 204);
				padding: 8px;
				box-sizing: border-box;
				cursor: pointer;

				@at-root #{$el}.active .xkit-ddl-buttons--clear, .xkit-ddl-buttons--arrow {
					color: rgb(102, 102, 102);
				}
				svg {
					display: inline-block;
					fill: currentcolor;
					line-height: 1;
					stroke: currentcolor;
					stroke-width: 0;
				}

			}
			.xkit-ddl-buttons--separator {
				align-self: stretch;
				width: 1px;
				background-color: rgb(204, 204, 204);
				margin-bottom: 8px;
				margin-top: 8px;
				box-sizing: border-box;
			}
		}
	}

	.xkit-ddl-menu {
		top: 100%;
		position: absolute;
		width: 100%;
		z-index: 3;
		background-color: rgb(255, 255, 255);
		border-radius: 4px;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 11px;
		margin-bottom: 8px;
		margin-top: 8px;
		box-sizing: border-box;
		.xkit-ddl-list {
			max-height: 300px;
			overflow-y: auto;
			position: relative;
			padding-bottom: 4px;
			padding-top: 4px;
			box-sizing: border-box;

			.xkit-ddl-item {
				cursor: default;
				display: block;
				font-size: inherit;
				width: 100%;
				user-select: none;
				-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
				background-color: transparent;
				color: inherit;
				padding: 8px 12px;
				box-sizing: border-box;
				&:hover {
					-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
					background-color: rgb(222, 235, 255);
				}
				&.selected {
					background-color: rgb(38, 132, 255);
					color: rgb(255, 255, 255);
				}

				&.info {
					font-style: italic;
					color: #ccc;
					&:hover {
						-webkit-tap-highlight-color: inherit;
						background-color: inherit;
					}
				}
			}
		}
	}

}
</style>